<template>
  <div id="bodorplus">
    <div class="header">
      <span class="back" @click="back">{{ $t("index.back") }}</span>
    </div>
    <div class="parent">
      <div class="info fadein-active">
        <div class="title">Bodor+3.0 APP</div>
        <div class="text">
          <span class="strong">{{ $t("index.plusHeader1") }}</span
          >{{ $t("index.plusHeader2") }}&nbsp;<span class="strong">{{
            $t("index.plusHeader3")
          }}</span
          >{{ $t("index.plusHeader4") }}
        </div>
        <div class="tip">{{ $t("index.plusSlide") }}</div>
        <svg
          t="1701999577676"
          class="down"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6914"
          width="60"
          height="60"
        >
          <path
            d="M493.504 558.144a31.904 31.904 0 0 0 45.28 0l308.352-308.352a31.968 31.968 0 1 0-45.248-45.248l-285.728 285.728-294.176-294.144a31.968 31.968 0 1 0-45.248 45.248l316.768 316.768z"
            p-id="6915"
            fill="#e6e6e6"
          ></path>
          <path
            d="M801.888 460.576l-285.728 285.728-294.144-294.144a31.968 31.968 0 1 0-45.248 45.248l316.768 316.768a31.904 31.904 0 0 0 45.28 0l308.352-308.352a32 32 0 1 0-45.28-45.248z"
            p-id="6916"
            fill="#e6e6e6"
          ></path>
        </svg>
      </div>
      <div class="imgbox" style="height: 1200px">
        <div
          class="videobg"
          style="transform: matrix(2.40969, 0, 0, 2.40969, 0, 0)"
          :style="{ backgroundImage: 'url(' + assetsUrl[1] + ')' }"
        >
          <div
            class="left"
            style="transform: matrix(1.55, 0, 0, 1.55, -862.5, -840)"
            :style="{ backgroundImage: 'url(' + assetsUrl[1] + ')' }"
          >
            <video :src="assetsUrl[0]" loop="loop" muted="muted" ref="video"></video>
          </div>
          <div
            class="code"
            style="transform: matrix(1.55, 0, 0, 1.55, 862.5, 840)"
            :style="{ backgroundImage: 'url(' + assetsUrl[2] + ')' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ref } from "vue";

let router = useRouter();
let route = useRoute();

const isVisitor = ref(route.params.isVisitor);
if (!isVisitor.value) {
  isVisitor.value = localStorage.getItem("isVisitor");
}

const assetsUrl = ref([
  require("@/assets/img/software/video.mp4"),
  require("@/assets/img/software/bg.png"),
  require("@/assets/img/software/code.png"),
]);

const video = ref(null);

const back = () => {
  if (isVisitor.value == "false") {
    router.push(`/index/software`);
  } else {
    router.push(`/visitor/software`);
  }
};

onMounted(() => {
  $(".info").show();
  var screenHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;
  var screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  var heightCoefficient = screenHeight / 950;
  var widthCoefficient = screenWidth / 1566;
  var minNumber =
    (widthCoefficient < heightCoefficient ? widthCoefficient : heightCoefficient) - 0.2;
  // 缩放最小大小
  var minMacbookScale = minNumber < 1 ? minNumber : 1;
  // 缩放初始大小
  var initMacbookScale = widthCoefficient + 1;
  // 缩放系数
  var coefficient = (initMacbookScale - minMacbookScale) / 750;
  // 放缩到最后整个macbook到顶部的高度
  var heightMacbook = minMacbookScale * 950 + 950;

  $(".videobg").css({
    transform: "matrix(" + initMacbookScale + ",0, 0," + initMacbookScale + ",0,0)",
  });
  $(".imgbox").css({ height: heightMacbook });
  if (window.document.getElementById("bodorplus")) {
    window.document.getElementById("bodorplus").addEventListener("scroll", computeCss);
  }
  function computeCss() {
    var height = $("#bodorplus").scrollTop();
    if (height > 0) {
      $(".info").hide();
    } else {
      $(".info").show();
    }
    if (height <= 750) {
      changebg(height);
    } else {
      changebg(750);
    }
  }
  function changebg(height) {
    if (height == 750) {
      video.value.play();
    } else {
      video.value.pause();
    }
    var macbookScale = initMacbookScale - coefficient * height;
    var macbookY = 100 + height;
    var imageScale = 1.55 - 0.0008 * height;
    var imageX = 700 - 1.05 * height;
    var imageY = 1150 - 1.5 * height;
    $(".videobg").css({
      transform:
        "matrix(" + macbookScale + ",0, 0," + macbookScale + ",0," + macbookY + ")",
    });
    $(".left").css({
      transform:
        "matrix(" +
        imageScale +
        ",0, 0," +
        imageScale +
        "," +
        -imageX +
        "," +
        -imageY +
        ")",
    });
    $(".code").css({
      transform:
        "matrix(" +
        imageScale +
        ",0, 0," +
        imageScale +
        "," +
        imageX +
        "," +
        imageY +
        ")",
    });
  }
});
</script>

<style scoped>
#bodorplus {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: white;
}
video {
  height: 100%;
  width: 100%;
}
.videobg {
  width: 1566px;
  height: 950px;
  transform-origin: center 88px;
  pointer-events: none;
  position: relative;
  left: 50%;
  margin-left: -783px;
  right: 0;
  margin-top: 0;
  transform-origin: center 88px;
}
.left {
  width: 960px;
  height: 540px;
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 170px;
  top: 84px;
  transform: matrix(1.55, 0, 0, 1.55, -860, -805);
  will-change: transform;
  left: 170px;
  top: 200px;
}
.code {
  position: absolute;
  width: 300px;
  height: 600px;
  background-size: 88%;
  background-repeat: no-repeat;
  top: 250px;
  right: 150px;
  transform: matrix(1.55, 0, 0, 1.55, -860, -805);
  will-change: transform;
}
.parent {
  background-repeat: no-repeat;
  background-position: 50% top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  background-size: cover;
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
}
.imgbox {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}
.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.info {
  position: absolute;
  top: 50vh;
  margin-top: -250px !important;
  margin-bottom: 0 !important;
  will-change: transform;
  z-index: 999;
  width: 100%;
  margin: 200px auto 0;
  text-align: center;
}
.text {
  font-weight: 590;
  font-size: 48px;
  line-height: 48px;
  color: white;
}
.title {
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 621;
  line-height: 20px;
  color: white;
}
.tip {
  color: rgba(255, 255, 255, 0.8);
  margin-top: 30px;
  margin-bottom: 50px;
}
.strong {
  background: linear-gradient(138.48deg, #ff4610 0%, #fcac45 86.3%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  color: transparent;
}
.fadein-active {
  -webkit-animation: fadeInUp 0.8s cubic-bezier(0.86, 0.01, 0.5, 1);
  -moz-animation: fadeInUp 0.8s cubic-bezier(0.86, 0.01, 0.5, 1);
  animation: fadeInUp 0.8s cubic-bezier(0.86, 0.01, 0.5, 1);
}
@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 70%, 0);
    transform: translate3d(0, 70%, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 70%, 0);
    transform: translate3d(0, 70%, 0);
  }
  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.down {
  animation: godown 2s infinite;
}
@keyframes godown {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
